import {useIntl} from 'react-intl';
import {useEffect} from 'react';
import {formDataLayerHelper} from 'utils/dataLayerHelper';

const RadioButtons = ({settings, onChange, setState}) => {
  const intl = useIntl();
  const {
    name,
    state,
    options,
    wrapperClasses,
    disabled = false,
  } = settings || {};
  const dataLayerCallback = formDataLayerHelper(intl, settings);

  useEffect(() => {
    options.forEach((option) => {
      if (option.checked) {
        setState((prev) => {
          return {
            ...prev,
            [name]: option.value,
          }
        });
      }
    });
  }, []);

  if (!name || !options) {
    return '';
  }

  const renderRadios = () => {
    return options.map((option) => {
      const {label, value, checked} = option;
      const isChecked = state[name] === value;
      const classes = `form-item form-item--radio ${isChecked ? 'form-item--radio-active' : ''} ${disabled ? 'form-disabled' : ''}`;

      return (
        <div className={classes} key={`option-${value}`}>
          <input className="form-radio"
                 name={name}
                 type="radio"
                 checked={state[name] ? isChecked : checked}
                 value={value}
                 disabled={disabled}
                 onChange={(event) => {
                   onChange(event);
                   if (typeof dataLayerCallback === 'function') {
                     dataLayerCallback(event);
                   }
                 }}
                 id={`${name}-${value}`}
          />
          <label className="option" htmlFor={`${name}-${value}`}>
            {intl.formatMessage({id: label})}
          </label>
        </div>
      );
    });
  };

  return (
    <div className={wrapperClasses}>
      {renderRadios()}
    </div>
  );
};

export default RadioButtons;
